import React, { useEffect, useMemo } from 'react';
import classNames from 'classnames/bind';
import { debounce } from 'lodash';
import { useResizeObserver } from 'usehooks-ts';

import type { ConsistencyTimestep } from 'types/consistency';
import useSetupForecastGraphConsistency from '../../hooks/useSetupForecastGraphConsistency';

import styles from './ForecastGraphConsistencyContainer.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  data: Array<ConsistencyTimestep | undefined>;
};

const ForecastGraphConsistencyContainer: React.FC<Props> = ({ data }) => {
  const canvasRef = React.useRef<HTMLDivElement | null>(null);

  const { height: graphHeight = 100, width: graphWidth = 320 } = useResizeObserver({
    ref: canvasRef,
  });

  const { setupForecastGraphConsistency } = useSetupForecastGraphConsistency({
    data,
    graphHeight,
    graphWidth,
  });

  const debouncedSetupForecastGraphConsistency = useMemo(
    () => debounce(setupForecastGraphConsistency, 100, { leading: true, trailing: true }),
    [setupForecastGraphConsistency],
  );

  useEffect(() => {
    if (graphWidth) debouncedSetupForecastGraphConsistency();

    return () => {
      debouncedSetupForecastGraphConsistency.cancel();
    };
  }, [graphWidth, debouncedSetupForecastGraphConsistency]);

  return (
    <div className={cx(['wave-consistency-graph', styles.wrapper])}>
      <div className={cx(['wave-consistency-graph-canvas', styles.canvas])} ref={canvasRef} />
    </div>
  );
};

export default ForecastGraphConsistencyContainer;
